import { Alert, Button, Input } from "antd"
import React, { useState } from "react"
import styled from "styled-components"

import { postPasswordConfirmationResend } from "../../actions/passwordAuth"
import { confirmationErrorKey, isValidEmail } from "../../helpers/passwordAuth"
import { t } from "../../lib/i18n"

type ConfirmationResendFormProps = {
  initialEmail?: string
}

// 確認メールの再送。auth-api は登録の有無に関わらず 200 を返すので、
// 成功時の文言も「届いていなければ」を前提に書く。
const ConfirmationResendForm = (
  props: ConfirmationResendFormProps,
): JSX.Element => {
  const [email, setEmail] = useState(props.initialEmail ?? "")
  const [submitting, setSubmitting] = useState(false)
  const [sent, setSent] = useState(false)
  const [errorKey, setErrorKey] = useState<string | null>(null)

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault()
    if (!isValidEmail(email)) {
      setErrorKey("invalid_email")
      return
    }

    setSubmitting(true)
    setErrorKey(null)
    const result = await postPasswordConfirmationResend(email.trim())
    setSubmitting(false)

    if (result.ok) {
      setSent(true)
      return
    }
    setErrorKey(confirmationErrorKey(result))
  }

  if (sent) {
    return <Alert type="success" message={t("email_confirm_resend_sent")} />
  }

  return (
    <StyledForm onSubmit={onSubmit} noValidate>
      <Input
        type="email"
        aria-label={t("email")}
        placeholder={t("email")}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        autoComplete="email"
      />
      {errorKey && <Alert type="error" message={t(errorKey)} />}
      <Button htmlType="submit" loading={submitting} block>
        {t("email_confirm_resend_submit")}
      </Button>
    </StyledForm>
  )
}

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 12px 0;
  width: 360px;
  max-width: 100%;
`

export default ConfirmationResendForm
